<ion-header>
    <ion-toolbar color="secondary">
        <ion-title>Privacy Policy</ion-title>

        <ion-buttons slot="end">
            <ion-button (click)="onClose()">
                <i class="material-symbols-outlined">close</i>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content fullscreen>
    <main>
        <section>
            <h2>Effective Date: 09/2025</h2>
            <p>
                Drive &amp; Tow ("we," "our," or "us") values your privacy. This Privacy Policy explains how we collect, use, and
                protect your information when you use the Drive &amp; Tow mobile application and related services (the "App").
            </p>

            <h2>Information We Collect</h2>
            <p>When you use our App, we may collect the following types of information:</p>
            <ul>
                <li>
                    <strong>Personal Information:</strong> Name, email address, phone number, and physical address provided during
                    account registration.
                </li>
                <li>
                    <strong>Payment Information:</strong> Payments are processed securely through Stripe. Drive &amp; Tow does not
                    store or have access to full credit card or bank account details.
                </li>
                <li>
                    <strong>Location Data:</strong> To match cargo/trailer owners with drivers, we may collect precise or
                    approximate location information.
                </li>
                <li>
                    <strong>Driver Information:</strong> Vehicle details and insurance documentation for drivers who register on the
                    platform.
                </li>
                <li>
                    <strong>Usage Data:</strong> App interactions, preferences, and technical logs (such as crash reports) to
                    improve app functionality.
                </li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>We use your data only for purposes related to providing and improving Drive &amp; Tow services, including:</p>
            <ul>
                <li>Matching cargo/trailer owners with drivers.</li>
                <li>Processing payments securely via Stripe.</li>
                <li>Providing customer support and account authentication.</li>
                <li>Enhancing safety, fraud prevention, and app reliability.</li>
	            <li>Sending push notifications for important updates, including new job requests, job status updates, and delivery confirmations.</li>
                <li>Enabling device features such as the camera and photo library so you can upload driver documents (license, insurance, registration) or profile photo.</li>
                <li>Complying with legal and tax obligations.</li>
            </ul>

            <h2>Sharing of Information</h2>
            <p>We do not sell your personal data. Your information may be shared only in these cases:</p>
            <ul>
                <li><strong>With Stripe:</strong> To process secure payments.</li>
                <li>
                    <strong>With Drivers or Cargo Owners:</strong> To complete transportation requests (limited to relevant details
                    like contact and trip information).
                </li>
                <li>
                    <strong>For Legal Reasons:</strong> If required to comply with applicable laws, regulations, or legal processes.
                </li>
                <li>
                    <strong>With Service Providers:</strong> For hosting, analytics, or app functionality support under strict
                    confidentiality agreements.
                </li>
            </ul>

            <h2>Data Security</h2>
            <p>
                We implement industry-standard security measures to protect your personal data. All sensitive information, including
                payment transactions, is encrypted. However, no method of transmission over the internet or mobile networks is 100%
                secure.
            </p>

            <h2>Your Rights</h2>
            <p>
                You may access, update, or delete your personal information through your account settings or by contacting us
                directly. You may also opt out of location tracking (though this may limit app functionality).
            </p>

            <h2>SMS/TEXT MESSAGING</h2>
            <p>
                To ensure you receive crucial job status notifications, Drive &amp; Tow may send you automated SMS text messages.
                You must actively opt in within your account settings to receive these updates.
            </p>
            <p>
                By providing your phone number, you consent to receive these messages and agree to the terms outlined in Drive &amp;
                Tow's Terms of Use. Standard message and data rates may apply.
            </p>
            <p>
                All information collected for text messaging is handled securely and in accordance with this Privacy Policy. You may
                opt out of SMS messages at any time by updating your preferences in your account settings.
            </p>

            <h2>Age Restrictions</h2>
            <p>
                Our services are not directed toward individuals under the age of 18. We do not knowingly collect personal data from
                minors.
            </p>

            <h2>Changes to this Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Changes will be posted within the App and updated with a new
                effective date.
            </p>

            <h2>Contact Us</h2>
            <p>
                If you have questions or concerns about this Privacy Policy, please contact us at:
                <a [href]="'mailto:' + email">{{ email }}</a>
            </p>
        </section>
    </main>
</ion-content>

<ion-footer class="ion-no-border">
    <ion-button type="button" expand="block" (click)="onClose()"> Close </ion-button>
</ion-footer>
